export default __webpack_public_path__ + "static/release-conditions-light-mode-1177ddffbf479e452e80ff1a3d484aa0.png";